import { createFileRoute } from "@tanstack/react-router";
import SavRoleManagement from "../../../pages/SavRoleManagement";

export const Route = createFileRoute("/admin/sav-role-management/")({
  component: SavRoleManagement,
});
